<template>
  <div class="vx-auto-suggest">
    <div class="flex items-center relative">
      <!-- Input @keyup.enter="suggestionSelected" icon-pack="feather"
        icon="icon-search" icon-no-border-->
      <el-input
        ref="input"
        :placeholder="placeholder"
        :class="inputClassses"    
        v-model="searchQuery"
        :disabled="disabled"
        @keyup.enter="suggestionSelected(true)"
        @keyup.esc="escPressed"
        @keyup.up="increaseIndex(false)"
        @keyup.down="increaseIndex(true)"        
        @focus="updateInputFocus"
        @blur="updateInputFocus(false)"
        @input="change($event)" />
    </div>
    <ul
      ref="scrollContainer"
      :class="{'hidden': !inputFocused}"
      class="auto-suggest-suggestions-list shadow-lg overflow-x-hidden"
      @mouseenter="insideSuggestions = true"
      @mouseleave="insideSuggestions = false"
      @focus="updateInputFocus"
      @blur="updateInputFocus(false)"
      tabindex="-1">

      <li
        ref="grp_list"
        v-for="(item, index) in data"
        :key="item.id ? item.id : index"
        class="auto-suggest__suggestion-group-container"
        :class="{'vx-auto-suggest__current-selected': currentSelected == index}"
        @mouseenter="currentSelected = index"
        @click="suggestionSelected(item)">
          {{item[showName]}}
      </li>
       <li class="auto-suggest__suggestion-group__suggestion py-3 px-4 no-results"
          v-if="!data.length && searchQuery">
        <slot name="noResult">
            <p>暂无数据</p>
        </slot>
      </li>
    </ul>
  </div>
</template>

<script>
export default{
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: 'Search..'
    },
    data: {
      type: Array,
      required: true
    },
    showName:{
      type: String,
      default: 'name'
    },
    inputClassses: {
      type: [String, Object, Array]
    },
    autoFocus: {
      type: Boolean,
      default: false
    },
    remainInputValue:{
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      searchQuery: '',
      currentSelected: 0,
      inputFocused: false,
      insideSuggestions: false
    }
  },
  watch: {
    //模糊搜索词
    searchQuery (val) {
      this.$emit('input', val);
      this.currentSelected = 0;
      if(val != ''){
        this.inputFocused = true;
      }else{
        this.inputFocused = false;
      }
    },
    autoFocus (val) {
      if (val) this.focusInput()
      else this.searchQuery = ''
    },
    data: {
      handler: function(newVal, oldVal) {
        console.log('===data====');
        console.log(this.data);
      },
      deep: true
      
    },

  },
  methods: {
    change(){
      this.$forceUpdate();
    },
    escPressed () {
     // this.$emit('closeSearchbar')
      //this.searchQuery = ''
    },
    updateInputFocus (val = true) {
      if(this.searchQuery == ''){
         
        setTimeout(() => {
          this.inputFocused = false
        }, 100)
        this.escPressed()
      }
    },
    suggestionSelected (item) {
      let resSelect;
      if(typeof item == "boolean"){
        resSelect = this.data[this.currentSelected];
      }else{
        resSelect = item;
      }
      this.searchQuery = resSelect[this.showName];
      setTimeout(() => {
          this.inputFocused = false
        }, 100)
      this.$emit('selected', resSelect);
      //是否保留选择的值
      if(!this.remainInputValue){
        this.searchQuery = '';
      }
    },
    increaseIndex (increase) {
      let resNum = this.currentSelected; 
      if(increase){//向下
        resNum++;        
        if(resNum > this.data.length) {
          resNum = 0;
        }
      }else{//向下
        resNum--; 
        if(resNum < 0) {
          resNum = 0;
        }  
      }
      this.currentSelected = resNum;
    },
    focusInput () {
      this.$refs.input.$el.querySelector('input').focus()
    }
  },
  mounted () {
    if (this.autoFocus) this.focusInput()
  }
}
</script>

<style lang="scss" scoped>
  @import "@/assets/scss/vuexy/components/vxAutoSuggest.scss";
  .vx-auto-suggest{
    width: 100%;
    position: relative;
    .auto-suggest-suggestions-list{  
      z-index: 200;
      border-bottom-left-radius: 6px;
      border-bottom-right-radius: 6px;
      max-height: 200px;
      overflow: auto;
      z-index: 20;
    }
    li{
      padding: 5px 20px;
    }
    li:hover{
      cursor: pointer;  
    }
    .vx-auto-suggest__current-selected{
      background-color: rgba(var(--vs-primary), 1);
      color: #fff;
    }
    /deep/ .vs-inputx.vs-input--input{
      border-color: rgba(var(--vs-primary), 1) !important;
    }
    .buyer-full /deep/ .vs-inputx.vs-input--input{
      border-color: rgba(0, 0, 0, 0.2) !important;
    }
  } 
</style>
